import { useContext } from 'react';
import { TabContext } from '../../Context/TabContext';
import Tab from './Tab/Tab';
import Wrapper from './Wrapper';
import './Tabs.css';
import { isMobile } from '../../../utils/isMobile';

function Tabs() {
  const tabContext = useContext(TabContext);

  let tabs = null;
  if (Array.isArray(tabContext.tabs) === true) {
    tabs = tabContext.tabs.map((tab) => {
      const style = ['tab_title'];
      const deleteStyle = ['deleteTab'];
      if (tabContext.activeComponent === tab.type) {
        style.push('active');
      }
      if (tabContext.tabs[0].type === tab.type) {
        deleteStyle.push('invisible');
      }
      return (
        <Tab key={tab.type} tab={tab} style={style} deleteStyle={deleteStyle} />
      );
    });
  }

  return (
    // <div style={{ display: 'flex', height: 'calc(100% - 30px)' }}>
    <div style={{ display: 'flex', height: isMobile() ? '' : '100%' }}>
      <div className="main">
        <div className="tabs_wrapper">{tabs}</div>
        <div className="wrapper_component">
          <Wrapper />
        </div>
      </div>
    </div>
  );
}

export default Tabs;
